import logo from './logo.svg';
import './App.css';
import Navbar from './Navbar';
import Images from './Images';
import Footer from './footer';


function App() {
  return (
    <div className="App">
     <Navbar />
     <Images />
     <Footer />
    </div>
  );
}

export default App;